import Aquamarine from 'features/home/images/headerGradient/Aquamarine.png'
import Coral from 'features/home/images/headerGradient/Coral.png'
import DeepPink from 'features/home/images/headerGradient/DeepPink.png'
import Gold from 'features/home/images/headerGradient/Gold.png'
import Lilac from 'features/home/images/headerGradient/Lilac.png'
import SkyBlue from 'features/home/images/headerGradient/SkyBlue.png'

export const gradientImagesMapping = {
  Gold,
  Aquamarine,
  SkyBlue,
  DeepPink,
  Coral,
  Lilac,
}
